// components/BlogSection.js
import { useRouter } from 'next/router'
import { BlogPost } from './BlogPost'
import { BlogFeaturedPost } from './BlogFeaturedPost'

const BlogSection = ({
    initialPosts,
    initialCategories,
    initialTotalPages,
    initialPage,
    paginationPrefix,
    isBlog = false,
}) => {
    const router = useRouter()

    const pagePrefix = paginationPrefix ? `/${paginationPrefix}` : ''
    const shouldShowFeaturedPost = isBlog && initialPage === 1
    const handlePreviousPage = () => {
        if (initialPage > 1) {
            const previousPage = initialPage - 1
            router.push(`/blog/${pagePrefix}/page/${previousPage}`)
        }
    }

    const handleNextPage = () => {
        if (initialPage < initialTotalPages) {
            const nextPage = initialPage + 1
            router.push(`/blog/${pagePrefix}/page/${nextPage}`)
        }
    }

    return (
        <div>
            {initialPosts.length > 0 ? (
                <div>
                    {shouldShowFeaturedPost && (
                        <BlogFeaturedPost
                            post={initialPosts[0]}
                            categories={initialCategories}
                        />
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {initialPosts
                            .slice(shouldShowFeaturedPost ? 1 : 0)
                            .map((post) => (
                                <BlogPost
                                    key={post.id}
                                    post={post}
                                    categories={initialCategories}
                                />
                            ))}
                    </div>
                    <div className="flex justify-between mt-6">
                        <button
                            onClick={handlePreviousPage}
                            disabled={initialPage === 1}
                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded disabled:opacity-50">
                            Previous
                        </button>
                        <button
                            onClick={handleNextPage}
                            disabled={initialPage === initialTotalPages}
                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded disabled:opacity-50">
                            Next
                        </button>
                    </div>
                </div>
            ) : (
                <div className="text-center py-10">
                    <p className="text-gray-600">No posts found.</p>
                </div>
            )}
        </div>
    )
}

export default BlogSection
